<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: column;">
      <iframe class="entireView" v-bind:src="'https://marineremote.maps.arcgis.com/apps/opsdashboard/index.html#/' + $route.params.id" frameborder="0" @load="finishLoading()"></iframe>
      <router-link :to="{name: 'Home'}" class="backBtn">Back to aquaticX</router-link>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
    //Loading,
  },
  data: () => ({
    items: []
  }),
  mounted() {
    var globv = this;
    //globv.$refs.loadScreen.startLoading()
    globv.login();
  },
  methods: {
    finishLoading: function() {
      var globv = this;
      globv.$refs.loadScreen.finishLoading();
    },
    login: function() {}
  },
  watch: {
  }
}
</script>

<style lang="scss">
.arcgisItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    width: 100%;
    flex: 1 0 auto;

    > .card {
        max-width: 1140px;
        width: 80%;
    }

    .dashFlexContent {
        width: 80%;

        .chart {
            width: 400px;
        }
    }
}

.contentButton {
  display: flex;
  position: absolute;
  top: 10px;
  right: 10px;

  a {
    padding: 5px 10px;
    display: flex;
    align-items: flex-end;
  }
}

.contentBtn {
    align-self: center;
    background-color: #2f55a4;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    text-decoration: none;
    padding: 10px 12px;
    border-radius: 5px;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover, &:focus, &:active {
        transform: scale(1.1);
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
    }
}

.backBtn {
    align-self: center;
    background-color: #2f55a4;
    position: absolute;
    bottom: 10px;
    right: 10px;
    top: inherit;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    text-decoration: none;
    padding: 10px 12px;
    border-radius: 5px;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover, &:focus, &:active {
        transform: scale(1.1);
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
    }
}
</style>